import { render, staticRenderFns } from "./delivery-boy.vue?vue&type=template&id=60e6b765&"
import script from "./delivery-boy.vue?vue&type=script&lang=js&"
export * from "./delivery-boy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports